<template>
    <vue-scroll>
        <single
            v-if="!$route.query.action || movedLocation || copiedLocation"
            ref="single"
            :location-to-be-moved="movedLocation"
            :location-to-be-copied="copiedLocation"
        />
    </vue-scroll>
</template>

<script>
import Single from "./Single";
import unsaved_changes_mixin from "../../../mixins/unsaved-changes";

export default {
    mixins: [unsaved_changes_mixin],
    components: {
        Single,
    },
    beforeRouteEnter(to, from, next) {
        if (to.query.action === "move-location") {
            axios
                .get(
                    `/web-api/community/${to.query.community_id}/location/${to.query.location_id}`
                )
                .then(({ data }) => {
                    next((vm) => vm.setMovedData({ movedLocation: data }));
                });
        } else if (to.query.action === "copy-location") {
            axios
                .get(
                    `/web-api/community/${to.query.community_id}/location/${to.query.location_id}`
                )
                .then(({ data }) => {
                    next((vm) => vm.setCopiedData({ copiedLocation: data }));
                });
        } else {
            next();
        }
    },
    data() {
        return {
            movedLocation: null,
            copiedLocation: null,
        };
    },
    computed: {
        hasChanges() {
            if (this.$refs.single) {
                return this.$refs.single.hasChanges;
            }
            return false;
        },
    },
    methods: {
        setMovedData({ movedLocation }) {
            this.movedLocation = movedLocation;
        },
        setCopiedData({ copiedLocation }) {
            this.copiedLocation = copiedLocation;
        },
    },
};
</script>

<style scoped></style>
